"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./useCurrentProviderGames"), exports);
__exportStar(require("./useFreespinsGames"), exports);
__exportStar(require("./useGame"), exports);
__exportStar(require("./useGameOfTheWeek"), exports);
__exportStar(require("./useGameUrl"), exports);
__exportStar(require("./useGamesByCategories"), exports);
__exportStar(require("./useGetGames"), exports);
__exportStar(require("./useGetGamesPayload"), exports);
__exportStar(require("./useGetGamesRounds"), exports);
__exportStar(require("./useJinnGames"), exports);
__exportStar(require("./useSearchGames"), exports);
__exportStar(require("./useSearchGamesByFilters"), exports);
__exportStar(require("./useSearchGamesInWithPagination"), exports);
__exportStar(require("./useScrollToCollections"), exports);
__exportStar(require("./useLastWinnersFlexInterval"), exports);
__exportStar(require("./useGameReport"), exports);
__exportStar(require("./useGameVPNRecommendations"), exports);
__exportStar(require("./useRecommendationsGamesByCategories"), exports);
__exportStar(require("./useRecommendationsGamesGamePage"), exports);
